<template>
    <!--  配置save val.pattern.custPage == "Sort" 表格排序-->
    <div id="modalSortTable">
        <a-modal
            title="Sort Table"
            :visible="visible"
            width="70%"
            @cancel="cancel"
        >
            <template slot="footer">
                <a-button type="primary" size="small" @click="saveSort" :disabled="disabledSort">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <div id="modalSortTableCon">
                <vxe-table
                        border
                        class="sortable-row-demo"
                        row-key
                        size="mini"
                        :data.sync="sortTableData"
                        ref="modalSortTableRefs"
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <template  v-for="(item, index) in cols">
                            <vxe-table-column
                                show-header-overflow
                                show-overflow
                                :width="item.proWidth == null ? '300' : item.proWidth">
                                <template v-slot:header="{ column }">
                                      <a-tooltip placement="topLeft">
                                        <template slot="title">
                                            <span>{{item.description == null ? "-" : item.description}}</span>
                                        </template>
                                        <span> {{ item.title }}</span>
                                    </a-tooltip>
                                </template>
                                <template v-slot="{ row }">
                                    <img
                                            v-if="row[item.label].config.fieldType == 'Image'"
                                            :src="row[item.label].value"
                                            width="80"
                                            height="30"
                                    />
                                    <div v-else>
                                        <a-tooltip placement="bottomLeft">
                                            <template slot="title">
                                              <span v-cloak>{{
                                                  row[item.label].value == null
                                                      ? "-"
                                                      : row[item.label].value
                                                  }}</span>
                                            </template>
                                            <span
                                                v-cloak>{{ row[item.label].value | textValFilter(item)}}</span>
                                        </a-tooltip>
                                    </div>
                                </template>
                            </vxe-table-column>
                    </template>
                </vxe-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
    import Sortable from "sortablejs";
    import ajax from '../../api/ajax'
    import api from '../../api/url'
    export default{
        data(){
            return{
                visible: false,
                sortTableData: [],
                cols: [],
                gmcUid: null ,// 子表传过来的uid
                disabledSort: false
            }
        },
//        销毁钩子
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        },
        filters: {
//            过滤时间
            textValFilter: function (val,params) {
                if(val == null){
                    return '-'
                }else{
                    if(params.type == "Datetime"){
                        if(params.dataFormat != null){
                            let t = moment(val).format(params.dataFormat);
                            return t
                        }else{
                            return val
                        }
                    }else if(params.type == "Decimal"){
                        if(params.dataFormat != null){
                            let t = this.pub_decimaltoFixed(val, params.dataFormat)
                            return t
                        }else{
                            return val
                        }
                    }else{
                        return val
                    }
                }
            },
        },
        methods:{
//          取消关闭
            cancel(){
                this.visible = false
            },
//            打开
            show(clos,data,uid){
                this.gmcUid = uid
                this.visible = true
                this.cols = JSON.parse(JSON.stringify(clos))
                this.sortTableData = JSON.parse(JSON.stringify(data))
                this.rowDrop()
            },
//         推拽表格排序
            rowDrop() {
                this.$nextTick(() => {
                    let sortTable = this.$refs.modalSortTableRefs
                    let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                        onEnd: ({ newIndex, oldIndex }) => {
                            let currRow = this.sortTableData.splice(oldIndex, 1)[0];
                            this.sortTableData.splice(newIndex, 0, currRow);
                        }
                    });
                });
            },
//            保存
            saveSort(){
                let params = {
                    detailList: this.sortTableData,
                    gmcUid: this.gmcUid
                }
                this.disabledSort = true
                ajax.post(api.GENERICDETAILSEQ,params).then(res=>{
                    if(res.code == 200){
                        this.$emit("sortTableData", true);
                        this.visible = false
                        this.disabledSort = false
                    }
                })
            }
        }
    }
</script>